import React from 'react';

import { SVGComponentProps } from './svg.types';

const FreezeTableSVG = ({
  fill = 'currentColor',
  size = '1em',
  ...otherProps
}: Omit<SVGComponentProps, 'wrapperClass'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.401737 4.05609C1.34169 2.73647 3.45733 0.5 7.00018 0.5C10.543 0.5 12.6587 2.73647 13.5986 4.05609C13.8742 4.44301 14.012 4.63646 13.9996 4.97626C13.9872 5.31605 13.8292 5.50663 13.5133 5.88779C12.4264 7.19901 10.0804 9.5 7.00018 9.5C3.91996 9.5 1.57393 7.19901 0.487105 5.88779C0.171175 5.50663 0.0132091 5.31605 0.00077296 4.97626C-0.0116632 4.63646 0.126137 4.44301 0.401737 4.05609ZM6.99911 7.25C8.18861 7.25 9.15289 6.24264 9.15289 5C9.15289 3.75736 8.18861 2.75 6.99911 2.75C5.80961 2.75 4.84533 3.75736 4.84533 5C4.84533 6.24264 5.80961 7.25 6.99911 7.25Z"
        fill={fill}
      />
    </svg>
  );
};

export default FreezeTableSVG;
